// import { MASTER_PAGE_LOAD,
// MASTER_PAGE_LOAD_SUCCESS,
// MASTER_PAGE_LOAD_FAIL } from './actions';
import {
  GET_RECEIVED_GIFT_LIST,
  GET_RECEIVED_GIFT_LIST_SUCCESS,
  GET_RECEIVED_GIFT_LIST_FAIL,
  GET_REGISTERED_GIFT_LIST,
  GET_REGISTERED_GIFT_LIST_SUCCESS,
  GET_REGISTERED_GIFT_LIST_FAIL,
  GET_ALL_REGISTERED_GIFT_LIST,
  GET_ALL_REGISTERED_GIFT_LIST_SUCCESS,
  GET_ALL_REGISTERED_GIFT_LIST_FAIL,
  GET_PERSONAL_SHOPPING_LIST,
  GET_PERSONAL_SHOPPING_LIST_SUCCESS,
  GET_PERSONAL_SHOPPING_LIST_FAIL,
  GET_EVENT_SUMMARY_INFO,
  GET_EVENT_SUMMARY_INFO_FAIL,
  GET_EVENT_SUMMARY_INFO_SUCCESS,
  SET_FAVOURITE_GIFT,
  SET_FAVOURITE_GIFT_SUCCESS,
  SET_FAVOURITE_GIFT_FAIL,
  SET_QUANTITY,
  SET_QUANTITY_SUCCESS,
  SET_QUANTITY_FAIL,
  SET_DELIVERY_ADDRESS_SUCCESS,
  SET_MODE_OF_DELIVERY_ADDRESS,
  SET_MODE_OF_DELIVERY_SUCCESS,
  SET_MODE_OF_DELIVERY_FAIL,
  REMOVE_GIFT,
  GET_MESSAGES,
  GET_MESSAGES_SUCCESS,
  GET_MESSAGES_FAIL,
  GET_ALL_MESSAGES,
  GET_ALL_MESSAGES_SUCCESS, 
  GET_ALL_MESSAGES_FAIL,
  GET_ADD_AGAIN_GIFT,
  GET_ADD_AGAIN_GIFT_SUCCESS,
  GET_ADD_AGAIN_GIFT_FAIL,
  UPDATE_GIFT_ITEM_DETAILS,
  UPDATE_GIFT_ITEM_DETAILS_SUCCESS,
  UPDATE_GIFT_ITEM_DETAILS_FAIL,
  SEND_THANKYOU_MESSAGE_DETAILS,
  SEND_THANKYOU_MESSAGE_DETAILS_SUCCESS,
  SEND_THANKYOU_MESSAGE_DETAILS_FAIL,
  TRACK_ORDER,
  TRACK_ORDER_SUCCESS,
  TRACK_ORDER_FAIL,
  EVENT_SUMMARY_INFO,
  EVENT_SUMMARY_INFO_SUCCESS,
  EVENT_SUMMARY_INFO_FAIL,
  SET_NOTIFICATION_COUNT,
  UPDATE_FAVOURITE,GET_EVENT_DETAILS,GET_EVENT_DETAILS_SUCCESS,GET_EVENT_DETAILS_FAIL,GET_EVENT_THRESHOLD_GIFT_DETAILS,
  GET_EVENT_THRESHOLD_GIFT_DETAILS_SUCCESS,
  GET_EVENT_THRESHOLD_GIFT_DETAILS_FAIL,
  GET_GIFTLIST_MARKETING_CONTENT,
  GET_GIFTLIST_MARKETING_CONTENT_SUCCESS,
  GET_GIFTLIST_MARKETING_CONTENT_FAIL,
  GET_GIFTLIST_FOOTER_MARKETING_CONTENT,
  GET_GIFTLIST_FOOTER_MARKETING_CONTENT_SUCCESS,
  GET_GIFTLIST_FOOTER_MARKETING_CONTENT_FAIL,
  GET_PURCHASE_INFO_DETAILS,
  GET_PURCHASE_INFO_DETAILS_SUCCESS,
  GET_PURCHASE_INFO_DETAILS_FAIL,
  TRANSFERENCE_STATEMENT_TAB,
} from './actions';

const RESET_STORE = 'RESET_STORE';

const initialState = {
  // latest commit
  loading: true,
  loaded: false,
  editing: {},
  saveError: {},
  data: {
    receivedGiftList: {},
    registeredGiftList: {},
    allRegisteredGiftList: {},
    personalShoppingList: {},
    eventInfo: {},
    deliveryAddress: {},
    modeOfDelivery: {},
    messageInfo: {},
    allMessagesInfo: {},
    eventSummaryInfo: {},
    giftlistMarketingContent: {}
  },
  extraData: {},
  msgLoaded: false,
  sendThanksMsg: null,
  userEventDetails: {},
  userEventThresholdGiftDetails: {},
  purchaseInfoDetails: {},
  isTransferenceStatementTab: false,
  
};

export default function GiftList(state = initialState,
  action = {}) {
  switch (action.type) {
    case RESET_STORE:
      return initialState;
    case GET_RECEIVED_GIFT_LIST:
      return {
        ...state,
        loadingReceivedGifts: true,
      };
    case GET_RECEIVED_GIFT_LIST_SUCCESS: {
      // const currentPage = action.result && action.result.currentPage ? action.result.currentPage : '1';
      // const currentList = currentPage !== '1' && state.data && state.data.receivedGiftList ? state.data.receivedGiftList.filteredReceivedGiftList : {};
      // const currentItemsInfo = currentPage !== '1' && currentList && currentList.itemsInfo ? currentList.itemsInfo : [];
      // const itemsInfo = action.result && action.result.itemsInfo ? action.result.itemsInfo : [];
      return {
        ...state,
        loadingReceivedGifts: false,
        loaded: true,
        data: {
          ...state.data,
          receivedGiftList: {
            originalReceivedGiftList: {
              // ...currentList,
              ...action.result,
              // itemsInfo: [...currentItemsInfo,
              // ...itemsInfo],
            },
            appliedFilter: [],
            filteredReceivedGiftList: {
              // ...currentList,
              ...action.result,
              // itemsInfo: [...currentItemsInfo,
              // ...itemsInfo],
            },
          },
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case GET_RECEIVED_GIFT_LIST_FAIL:
      return {
        ...state,
        loadingReceivedGifts: false,
        loaded: false,
        data: null,
        error: action.error,
      };


    case EVENT_SUMMARY_INFO:
      return {
        ...state,
        loading: true,
      };
    case EVENT_SUMMARY_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          eventSummaryInfo: action.result,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case EVENT_SUMMARY_INFO_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };


    case TRACK_ORDER:
      return {
        ...state,
        loading: true,
        loadingTrackOrder: true,
        trackOrderFailed: false,
      };
    case TRACK_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        loadingTrackOrder: false,
        trackOrderFailed: false,
        data: {
          ...state.data,
          trackOrderInfo: action.result,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case TRACK_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        loadingTrackOrder: false,
        trackOrderFailed: true,
        loaded: false,
        data: null,
        error: action.error,
      };


    case GET_REGISTERED_GIFT_LIST:
      return {
        ...state,
        loadingRegisteredGifts: true,
      };
    case GET_REGISTERED_GIFT_LIST_SUCCESS: {
      return {
        ...state,
        loadingRegisteredGifts: false,
        loaded: true,
        data: {
          ...state.data,
          registeredGiftList: {
            // categoryInfo: updatedCategoryInfo,
            originalRegisteredGiftList: action.result,
            appliedFilter: [],
            filteredRegisteredGiftList: action.result,
          },
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    }

    case GET_ALL_REGISTERED_GIFT_LIST:
      return {
        ...state,
        loadingAllRegisteredGifts: true,
      };
    case GET_ALL_REGISTERED_GIFT_LIST_SUCCESS: {
      return {
        ...state,
        loadingAllRegisteredGifts: false,
        loaded: true,
        data: {
          ...state.data,
          allRegisteredGiftList: action.result,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    }

    case GET_ALL_REGISTERED_GIFT_LIST_FAIL:
      return {
        ...state,
        loadingAllRegisteredGifts: false,
        loaded: false,
        data: null,
        error: action.error,
      };


    case UPDATE_FAVOURITE: {
      const i = state.data.registeredGiftList;
      i && i.originalRegisteredGiftList && i.originalRegisteredGiftList.categoryItemsInfo && i.originalRegisteredGiftList.categoryItemsInfo.forEach((item) => {  
        item.itemInfo.forEach((sub) => {
          if (sub.giftItemId === action.data.giftItemId) {
            sub.isFavourite = action.data.status;  
          }
        });
      });
      return {
        ...state,
        // data: {
        //   ...state.data,
        //   registeredGiftList: {
        //     ...state.data.registeredGiftList,
        //   },
        // },
      };
    }

    case REMOVE_GIFT:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          registeredGiftList: {
            ...state.registeredGiftList,
            originalRegisteredGiftList: JSON.parse(JSON.stringify(action.data)),
            appliedFilter: [],
            filteredRegisteredGiftList: JSON.parse(JSON.stringify(action.data)),
          },
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_REGISTERED_GIFT_LIST_FAIL:
      return {
        ...state,
        loadingRegisteredGifts: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case GET_PERSONAL_SHOPPING_LIST:
      return {
        ...state,
        loadingPersonalGifts: true,
      };
    case GET_PERSONAL_SHOPPING_LIST_SUCCESS: {
      // const currentPage = action.result && action.result.currentPage ? action.result.currentPage : '1';
      // const currentList = currentPage !== '1' && state.data && state.data.personalShoppingList ? state.data.personalShoppingList.filteredPersonalShoppingList : {};
      // const currentItemsInfo = currentPage !== '1' && currentList && currentList.itemsInfo ? currentList.itemsInfo : [];
      // const itemsInfo = action.result && action.result.itemsInfo ? action.result.itemsInfo : [];
      return {
        ...state,
        loadingPersonalGifts: false,
        loaded: true,
        data: {
          ...state.data,
          personalShoppingList: {
            originalPersonalShoppingList: {
              // ...currentList,
              ...action.result,
              // itemsInfo: [...currentItemsInfo,
              // ...itemsInfo],
            },
            appliedFilter: [],
            filteredPersonalShoppingList: {
              // ...currentList,
              ...action.result,
              // itemsInfo: [...currentItemsInfo,
              // ...itemsInfo],
            },
          },
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    }
    case GET_PERSONAL_SHOPPING_LIST_FAIL:
      return {
        ...state,
        loadingPersonalGifts: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case GET_EVENT_SUMMARY_INFO:
      return {
        ...state,
        loading: true,
      };
    case GET_EVENT_SUMMARY_INFO_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          eventInfo: action.result.eventInfo,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_EVENT_SUMMARY_INFO_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case SET_FAVOURITE_GIFT:
      return {
        ...state,
        loading: true,
      };
    case SET_FAVOURITE_GIFT_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          favouriteGift: action.result.favouriteGift,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case SET_FAVOURITE_GIFT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SET_QUANTITY:
      return {
        ...state,
        loading: true,
      };
    case SET_QUANTITY_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          saveQuantity: action.result.saveQuantity,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case SET_QUANTITY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case GET_MESSAGES:
      return {
        ...state,
        loading: true,
      };
    case GET_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        msgLoaded: true,
        data: {
          ...state.data,
          messageInfo: action.result.messageInfo,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_MESSAGES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        msgLoaded: false,
        data: null,
        error: action.error,
      };
    case GET_ALL_MESSAGES:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_MESSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        msgLoaded: true,
        data: {
          ...state.data,
          allMessagesInfo: action.result.items,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_ALL_MESSAGES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        msgLoaded: false,
        data: null,
        error: action.error,
      };

    case GET_ADD_AGAIN_GIFT:
      return {
        ...state,
        loading: true,
      };
    case GET_ADD_AGAIN_GIFT_SUCCESS:

      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state,
          addAgainGiftItem: action.data,
        },
        error: null,
        extraData: 'This is extra info..........',
      };

    case GET_ADD_AGAIN_GIFT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };

    case SET_DELIVERY_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          registeredGiftList: {
            ...state.registeredGiftList,
            originalRegisteredGiftList: JSON.parse(JSON.stringify(action.data)),
            appliedFilter: [],
            filteredRegisteredGiftList: JSON.parse(JSON.stringify(action.data)),
          },
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case SET_MODE_OF_DELIVERY_ADDRESS:
      return {
        ...state,
        loading: true,
      };
    case SET_MODE_OF_DELIVERY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          registeredGiftList: {
            ...state.registeredGiftList,
            originalRegisteredGiftList: action.data,
            appliedFilter: [],
            filteredRegisteredGiftList: JSON.parse(JSON.stringify(action.data)),
          },
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case SET_MODE_OF_DELIVERY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case UPDATE_GIFT_ITEM_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_GIFT_ITEM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,

        error: null,
        extraData: 'This is extra info..........',
      };
    case UPDATE_GIFT_ITEM_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SEND_THANKYOU_MESSAGE_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case SEND_THANKYOU_MESSAGE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case SEND_THANKYOU_MESSAGE_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        // data: null,
        error: action.error,
      };
    case SET_NOTIFICATION_COUNT:
      return {
        ...state,
        notificationCount: action.data,
      };
    case GET_EVENT_DETAILS:
          return {
            ...state,
          };
    case GET_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        userEventDetails: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_EVENT_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case GET_EVENT_THRESHOLD_GIFT_DETAILS:
      return {
        ...state,
      };
    case GET_EVENT_THRESHOLD_GIFT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        userEventThresholdGiftDetails: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_EVENT_THRESHOLD_GIFT_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case GET_PURCHASE_INFO_DETAILS:
      return {
        ...state,
      };
    case GET_PURCHASE_INFO_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        purchaseInfoDetails: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_PURCHASE_INFO_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case GET_GIFTLIST_MARKETING_CONTENT:
      return {
        ...state,
      };
    case GET_GIFTLIST_MARKETING_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          giftlistMarketingContent: action.result,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_GIFTLIST_MARKETING_CONTENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case GET_GIFTLIST_FOOTER_MARKETING_CONTENT:
      return {
        ...state,
      };
    case GET_GIFTLIST_FOOTER_MARKETING_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: {
          ...state.data,
          giftlistFooterMarketingContent: action.result,
        },
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_GIFTLIST_FOOTER_MARKETING_CONTENT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case TRANSFERENCE_STATEMENT_TAB:
      return {
        ...state,
        isTransferenceStatementTab: action.data,
      };
    default:
      return state;
  }
}
